import { render, staticRenderFns } from "./IdleDialog.vue?vue&type=template&id=16387dad&scoped=true"
import script from "./IdleDialog.vue?vue&type=script&lang=js"
export * from "./IdleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16387dad",
  null
  
)

export default component.exports